import { render, staticRenderFns } from "./DataProfileSample.vue?vue&type=template&id=30b21ed4&"
import script from "./DataProfileSample.vue?vue&type=script&lang=js&"
export * from "./DataProfileSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports